import type { CreateOfertaEndesaModel, OfertaLuzModel, OfertaGasModel, CoordenadaFirma, OfertaEndesaModel, DetailOfertaEndesaModel, DescuentoEnergiaModel, ComisionEnergiaOfertaModel, VariableAnexoValor, TipoCosteGestionEnum } from '@api/api';
import { TipoTarifaEnergiaEnum, TipoSuministroTramiteEnergiaEnum } from '@api/api';
import { DatosOfertaLuz } from "../../base/models/DatosOfertaLuz";
import { DatosOfertaGas } from "../../base/models/DatosOfertaGas";
import { toUTCDateOnly } from '@helpers/date-parser-helper';
import { DatosOfertaEndesa } from './DatosOfertaEndesa';

export class CreateOfertaEndesa implements CreateOfertaEndesaModel {

    IdEmpresaServicios: string = '';
    Nombre: string = '';
    CodigoTalonario: string | null = null;
    FechaInicio: Date = new Date();
    FechaFin: Date = new Date();
    TipoEnergia: TipoSuministroTramiteEnergiaEnum = TipoSuministroTramiteEnergiaEnum.Luz;
    TipoTarifa: TipoTarifaEnergiaEnum = TipoTarifaEnergiaEnum.Libre;
    TarifaAcceso: string = '2.0TD';
    AplicaPersonaFisica: boolean = false;
    AplicaPersonaJuridica: boolean = false;
    DatosLuz: OfertaLuzModel | null = null;
    DatosGas: OfertaGasModel | null = null;
    Observaciones: string = '';
    Activa: boolean = true;
    CoordenadasFirma: CoordenadaFirma[] = [];
    RequiereRellenado: boolean = false;
    DenominacionInterna: string = '';
    TipoCosteGestion: TipoCosteGestionEnum | null = null;
    CosteGestion: number | null = null;
    DatosEndesa: OfertaEndesaModel;
    Descuentos: DescuentoEnergiaModel[] = [];
    Comisiones: ComisionEnergiaOfertaModel[] = [];
    IdAnexoEmpresaServicios: string | null = null;
    VariablesAnexo: VariableAnexoValor[] | null = null;

    EmpresaServicios: string = '';

    constructor(data?: Partial<CreateOfertaEndesa>) {
        Object.assign(this, data);

        if (data?.FechaFin == null)
            this.FechaFin.setDate(this.FechaFin.getDate() + 1)

        this.FechaInicio = toUTCDateOnly(this.FechaInicio);
        this.FechaFin = toUTCDateOnly(this.FechaFin);


        if (this.TipoEnergia == TipoSuministroTramiteEnergiaEnum.Luz)
            this.DatosLuz = new DatosOfertaLuz();

        if (this.TipoEnergia == TipoSuministroTramiteEnergiaEnum.Gas)
            this.DatosGas = new DatosOfertaGas();

        this.DatosEndesa = new DatosOfertaEndesa();
    }

    public createFromOfertaDetail(oferta: DetailOfertaEndesaModel): CreateOfertaEndesa {
        Object.assign(this, oferta);
        return this;
    }
}
